import React from 'react'
import { useDispatch } from 'react-redux'
import { EntityTypeEnum, WorkflowActions, ProductSectorMappingDetail, ProductSectorMappingStatus } from 'api'
import { Locale, Translation } from 'locale'
import { SplitButtonDropdown, ActionItem } from 'view/components/menus'
import { ActionsButtonProps } from 'view/components/datagrid'
import { useModal } from 'view/shared/modal'
import { SectorMappingEditDialog } from '../SectorMappingDialog/SectorMappingEditDialog'

export type SectorMappingActionsButtonProps = ActionsButtonProps<ProductSectorMappingDetail>

export const SectorMappingActionsButton: React.FC<SectorMappingActionsButtonProps> = ({ items }) => {
  const { showModal } = useModal()
  const dispatch = useDispatch()

  const handleEditItemDialog = (entityId: string) => {
    const correlatedResponseCallback = (workflowId: string) => {
      showModal(<SectorMappingEditDialog workflowId={workflowId} entityId={entityId} />)
    }
    dispatch(WorkflowActions.createEditWorkflow(EntityTypeEnum.PRODUCT_SECTOR_MAPPING_DRAFT, entityId, correlatedResponseCallback))
  }

  const handleDeleteItem = (entityId: string) => {
    const correlatedResponseCallback = (workflowId: string) => {
      dispatch(
        WorkflowActions.createEntityUpdateReferenceData({
          entityId,
          entityType: EntityTypeEnum.PRODUCT_SECTOR_MAPPING_DRAFT,
          updatedEntity: {
            ...items[0],
            status: ProductSectorMappingStatus.DELETED
          },
          workflowId
        })
      )
      dispatch(WorkflowActions.createSubmitWorkflow(workflowId))
    }
    dispatch(WorkflowActions.createEditWorkflow(EntityTypeEnum.PRODUCT_SECTOR_MAPPING_DRAFT, entityId, correlatedResponseCallback))
  }
  const actions: ActionItem[] = [
    {
      label: Locale.translate(Translation.TC_ACTION_EDIT_DETAILS),
      onClick: () => handleEditItemDialog(items[0].id)
    },
    {
      label: Locale.translate(Translation.TC_ACTION_DELETE),
      onClick: () => handleDeleteItem(items[0].id)
    }
  ]

  return <SplitButtonDropdown dataTestId={'SectorMappingActionsButton'} actions={actions} maxButtons={1} autoHideEllipsis={true} />
}
